import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { redirect } from "next/navigation";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function encodedRedirect(type, path, message) {
    return redirect(`${path}?${type}=${encodeURIComponent(message)}`);
}

export function formatNumber(num) {
    return new Intl.NumberFormat().format(num);
}

export function allNull(obj) {
    if (obj === null) return true;
    return Object.values(obj).every((v) => v === null || (typeof v === "object" && Object.values(v).every((x) => x === null)));
}
